export default "/images/anchor_fm.png?157fec73f5b0cbcc0d5f202b65e4575b";